import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './components/Header';
import Hero from './components/Hero';
import Problems from './components/Problems';
import Features from './components/Features';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import ExitIntentModal from './components/ExitIntentModal';
import WhatsAppButton from './components/WhatsAppButton';
import LeadCaptureModal from './components/LeadCaptureModal';
import { storeTrackingData } from './utils/tracking';
import './App.css';

function App() {
  const [showExitIntent, setShowExitIntent] = useState(false);
  const [showLeadCapture, setShowLeadCapture] = useState(false);
  const [firstPopupShown, setFirstPopupShown] = useState(false);

  useEffect(() => {
    // Store tracking data on app load
    storeTrackingData();

    let exitIntentShown = false;

    const handleMouseLeave = (e) => {
      if (e.clientY <= 0 && !exitIntentShown) {
        setShowExitIntent(true);
        exitIntentShown = true;
      }
    };

    // Show lead capture modal after 8 seconds (first popup)
    const firstPopupTimer = setTimeout(() => {
      setShowLeadCapture(true);
      setFirstPopupShown(true);
    }, 8000);

    document.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
      clearTimeout(firstPopupTimer);
    };
  }, []);

  const handleLeadCaptureClose = () => {
    setShowLeadCapture(false);

    // If this was the first popup, schedule the second popup after 30 seconds
    if (firstPopupShown) {
      setTimeout(() => {
        setShowLeadCapture(true);
      }, 30000);
    }
  };

  const openLeadCapture = () => {
    setShowLeadCapture(true);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero openLeadCapture={openLeadCapture} />
      <Problems />
      <Features />
      <Pricing />
      <Testimonials />
      <FAQ />
      <Footer openLeadCapture={openLeadCapture} />
      <WhatsAppButton />

      <AnimatePresence>
        {showExitIntent && <ExitIntentModal onClose={() => setShowExitIntent(false)} />}
      </AnimatePresence>

      <LeadCaptureModal isOpen={showLeadCapture} onClose={handleLeadCaptureClose} />
    </div>
  );
}

export default App;